import { useDeviceType } from '@vfit/shared/hooks';
import { purify } from '@vfit/shared/themes';
import { IUseEditorialCardsSwiper } from './editorialCardsSwiper.models';

export const useEditorialCardsSwiper = ({ title }: IUseEditorialCardsSwiper) => {
  const { isMobile } = useDeviceType();

  const [pTitle] = purify([title]);

  return {
    isMobile,
    pTitle,
  };
};

